<template>
  <!-- <v-main app class=login_back> -->
    <!-- <v-container class="fill-height" fluid> -->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5" lg=4 xl=4>
          <v-card class="elevation-12 form-back">
            <v-card-title class="box-gradient box-caption">{{$t('title.login')}}</v-card-title>
            <v-card-text>
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
                class="mt-5"
              >{{alertMessage}}</v-alert>
              <v-form ref="form" :lazy-validation="true" id="lform">
                <SelectLocale class="justify-end" />
                <v-text-field
                  v-model.trim="domen"
                  :placeholder="$t('login.domain')"
                  name="domain"
                  :rules="userRules"
                  outlined
                  shaped
                  prepend-icon="fa-link"
                  class="mt-4"
                  required
                />
                <v-text-field
                  v-model.trim="user"
                  :placeholder="$t('login.login')"
                  name="login"
                  outlined
                  shaped
                  :rules="userRules"
                  prepend-icon="mdi-account"
                  required
                />
                <v-text-field
                  v-model.trim="pass"
                  id="password"
                  :placeholder="$t('login.pass')"
                  outlined
                  shaped
                  name="password"
                  :rules="userRules"
                  prepend-icon="mdi-lock"
                  type="password"
                  @keypress.enter="login"
                  required
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary box-gradient mr-2 mb-2"
                rounded
                @click="login"
              >{{$t('button.login')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    <!-- </v-container> -->
  <!-- </v-main> -->
</template>

<script>
import SelectLocale from "@/components/Select-locale";
//import app from "@/app.js";

export default {
  components: { SelectLocale },
  data() {
    return {
      showAlert: false,
      alertMessage: "",
      user: "",
      userRules: [v => !!v || this.$t("error.required")],
      pass: "",
      domen: ""
    };
  },
  mounted() {
    this.$store.commit("user/clearUser");
    this.$store.commit("struct/clean");
    this.$store.commit("report/clear_data");
    this.$store.commit("admin/clean");
    this.$store.commit("clearSettings");
  },
  methods: {
    showAlertMessage(m) {
      this.showAlert = true;
      this.alertMessage = m;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
    async login() {
      try {
        this.$store.commit("user/clearUser");
        this.$store.commit("struct/clean");
        this.$store.commit("report/clear_data");
        this.$store.commit("admin/clean");
        this.$store.commit("clearSettings");
      } catch (e) {
        console.log(e);
      }
      if (!this.$refs.form.validate()) return;
      this.showAlert = false;
      try {
        let result = await this.$store.dispatch("user/LOGIN", {
          pars: {
            domain: this.domen,
            user: this.user,
            pass: this.pass
          },
          __vm: this
        });
        if (result) this.$router.push("/");
      } catch (e) {
        this.showAlertMessage(e);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-back {
  /*  background-color: rgb(232, 240, 254);*/
  border-radius: 25px !important;
}
.box-gradient {
  background: linear-gradient(
    180deg,
    rgba(101, 192, 94, 1) 0%,
    rgba(230, 230, 230, 1) 2%,
    rgba(101, 192, 94, 1) 4%,
    rgba(52, 187, 144, 1) 100%
  );
}
.box-caption {
  height: 73px;
  color: white;
  font-size: 29px;
  font-weight: 600;
}
</style>
